import React, { PropTypes } from 'react';

const ReferralFormRadioGroup = (props) => {
  const { input, name, label, isRequired, options, meta: { touched, error } }  = props;
  const hasError = touched && error;

  return (
    <div>
      <label>
        {label}
        {isRequired && <span className="required"> *</span>}
      </label>
      <div className="small-fields small-radio-buttons">
        {options.map(o => (
          <div className="option-small" key={o.value}>
            <input
              {...input}
              type="radio"
              className={hasError ? 'is-invalid-input' : ''}
              value={o.value}
              checked={o.value === input.value}
              id={`${name}-${o.value}`}
            />
            <label htmlFor={`${name}-${o.value}`} >
              {o.title}
            </label>
          </div>
        ))}
      </div>
      {hasError && <span className="form-error is-visible">{error}</span>}
    </div>
  );
};

ReferralFormRadioGroup.propTypes = {
  input: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.array,
  meta: PropTypes.object
};

export default ReferralFormRadioGroup;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/ReferralFormRadioGroup/index.js
 **/